import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

const CondolenceMailGroups = () => {
  const navigate = useNavigate();
  const [groups, setGroups] = useState({ A: '', B: '', C: '' });
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(null);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const load = useCallback(() => {
    fetch('/api/condolence/admin/mail-groups', { credentials: 'include' })
      .then(res => {
        if (res.status === 403) { navigate('/condolence/menu'); return null; }
        if (!res.ok) { navigate('/condolence'); return null; }
        return res.json();
      })
      .then(data => {
        if (data && data.groups) setGroups(data.groups);
      })
      .catch(() => setError('一覧の取得に失敗しました'))
      .finally(() => setLoading(false));
  }, [navigate]);

  useEffect(() => { load(); }, [load]);

  const handleSave = async (key) => {
    setSaving(key);
    setMessage('');
    setError('');
    try {
      const res = await fetch('/api/condolence/admin/mail-groups', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ group_key: key, recipients: groups[key] || '' }),
      });
      const data = await res.json();
      if (res.ok) {
        setMessage(`グループ${key} を保存しました`);
      } else {
        setError(data.error || '保存に失敗しました');
      }
    } catch {
      setError('通信エラーが発生しました');
    } finally {
      setSaving(null);
    }
  };

  const groupMeta = {
    A: { label: 'A: 本社', desc: '訃報必要 × 店舗系/別系列、または本部系全般 で送付' },
    B: { label: 'B: 全店役職', desc: '訃報必要 × 店舗系の社員 で追加送付' },
    C: { label: 'C: 管理部門', desc: '訃報不要、または本部系の訃報不要 で送付' },
  };

  return (
    <div className="form-page">
      <header className="form-header" style={{ background: '#37474f' }}>
        <button className="back-button" onClick={() => navigate('/condolence/menu')}>← 戻る</button>
        <h1>メールグループ設定（A/B/C）</h1>
      </header>

      <main className="form-main">
        <div className="section-bar" style={{ background: '#eceff1' }}>
          <span className="icon">✉️</span>
          <span className="title" style={{ color: '#37474f' }}>全社共通の送信先</span>
        </div>

        <div className="form-card">
          <p style={{ fontSize: '13px', color: '#666', marginBottom: '16px' }}>
            ※ 訃報送信先の全社共通グループです。各グループに複数アドレスをカンマ区切りで入力してください。<br />
            ※ 自店役職者（D）は<a href="/condolence/obituary-recipients" style={{ color: '#37474f' }}>店舗別設定</a>で別途編集してください。
          </p>

          {message && (
            <div style={{
              background: '#e8f5e9', border: '1px solid #66bb6a', borderRadius: '6px',
              padding: '12px', marginBottom: '16px', color: '#2e7d32'
            }}>{message}</div>
          )}
          {error && <div className="error-message">{error}</div>}

          {loading ? (
            <p style={{ textAlign: 'center', color: '#666' }}>読み込み中...</p>
          ) : (
            <>
              {['A', 'B', 'C'].map(k => (
                <div key={k} style={{ marginBottom: '24px', padding: '16px', background: '#f9f9f9', borderRadius: '8px' }}>
                  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '4px' }}>
                    <strong style={{ fontSize: '15px', color: '#37474f' }}>{groupMeta[k].label}</strong>
                    <button
                      onClick={() => handleSave(k)}
                      disabled={saving === k}
                      style={{
                        padding: '6px 16px', fontSize: '13px',
                        background: '#37474f', color: 'white',
                        border: 'none', borderRadius: '4px', cursor: 'pointer',
                      }}
                    >
                      {saving === k ? '保存中...' : '保存'}
                    </button>
                  </div>
                  <div style={{ fontSize: '12px', color: '#888', marginBottom: '8px' }}>
                    {groupMeta[k].desc}
                  </div>
                  <textarea
                    value={groups[k] || ''}
                    onChange={(e) => setGroups({ ...groups, [k]: e.target.value })}
                    placeholder="aaa@example.jp, bbb@example.jp"
                    rows={2}
                    style={{
                      width: '100%', padding: '8px 10px',
                      border: '1px solid #ddd', borderRadius: '4px',
                      fontSize: '13px', resize: 'vertical', fontFamily: 'inherit'
                    }}
                  />
                </div>
              ))}
            </>
          )}
        </div>
      </main>
    </div>
  );
};

export default CondolenceMailGroups;
